import type { ChatAction, PluckedAction } from "~vue/chatActions";
import type { ComputedRef, InjectionKey } from "vue";

export const taggedPeopleKey: InjectionKey<ComputedRef<PluckedAction<ChatAction.TAGGED_PERSON>[]>> = Symbol("taggedPeople");

// A person Nadia created from this mention that the user hasn't confirmed yet.
export const isUnconfirmedTaggedPerson = ({ line }: PluckedAction<ChatAction.TAGGED_PERSON>): boolean => {
    const params = line.action_params;
    return !line.action_state?.submitted && params.was_created && !!(params.name || params.title || params.relationship);
};
